module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2021-video-cover.2b876bd7.jpg";